<script>
  import { onMount } from "svelte";
  import { writable } from "svelte/store";
  import Conexoes from "../../Classes/Conexoes";
  import Constantes from "../../Classes/Constantes";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
  import { DadosLogin } from "../../Classes/Stores";
  import FeedbackModal from "./ModalFeedBackCorrida.svelte"; // Importando o novo componente
  import DropSelecao from "../../componentes_basicos/DropSelecao.svelte";
  import CalendarioTreino from "../../componentes_basicos/CalendarioTreino.svelte";
    import CardZonas from "./CardZonas.svelte";
  let id_assessoria = $DadosLogin.id_assessoria;
  const conexao = new Conexoes();
  let hoje = new Date();
  let currentMonth = hoje.getMonth();
  let currentYear = hoje.getFullYear();
  let dias = writable([]);
  let isLoading = false;
  let dadosTreino = [];
  let message;
  let title;
  let selectedDia = null; // Dia selecionado para feedback
  let showModal = false;

  export let id_usuario = "";

  let soCalendario = false;

  function GravaFiltro() {
    localStorage.setItem("filtro_treino", filtro);
    console.log(localStorage.getItem("filtro_treino"));
    InciaTela();
  } 
  function atualizarDatas(mes, ano) {
    let datas = [];
    let diasNoMes = new Date(Date.UTC(ano, mes + 1, 0)).getDate();

    for (let i = 1; i <= diasNoMes; i++) {
      let data = new Date(Date.UTC(ano, mes, i + 1));
      let treinosNoDia = dadosTreino.filter((t) => {
        return (
          new Date(
            Date.UTC(
              t.data.getUTCFullYear(),
              t.data.getUTCMonth(),
              t.data.getUTCDate(),
            ),
          ).toDateString() === data.toDateString()
        );
      });
      datas.push({ data, treinos: treinosNoDia });
    }

    dias.set(datas);
    console.log("dias ", datas);
  }

  function incrementarMes() {
    currentMonth++;
    if (currentMonth > 11) {
      currentMonth = 0;
      currentYear++;
    }
    PegaDados();
  }

  function decrementarMes() {
    currentMonth--;
    if (currentMonth < 0) {
      currentMonth = 11;
      currentYear--;
    }
    PegaDados();
  }

  async function PegaDados() {
    isLoading = true;
    let resultado = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: "consulta_planilha_corrida",
      id_usuario: id_usuario,
      mes: currentMonth + 1,
    });
    if (resultado && resultado.length > 0) {
      dadosTreino = (resultado || []).map((item) => {
        let [year, month, day] = item.data.split("-").map(Number);
        return {
          ...item,
          data: new Date(Date.UTC(year, month - 1, day , 0, 0, 0)),
        };
      });
    }
    isLoading = false;
    atualizarDatas(currentMonth, currentYear);
    AtualizaScroll();
  }

  function AtualizaScroll() {
    setTimeout(() => {
      const elementoAtual = document.querySelector(`#day-${hoje.getDate()}`);
      if (elementoAtual && currentMonth == hoje.getMonth()) {
        const stickyHeaderHeight =
          document.querySelector(".sticky-header").offsetHeight;
        const offsetPosition = elementoAtual.offsetTop - stickyHeaderHeight;

        document.querySelector(".calendar-body").scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }, 0);
  }

  function openFeedbackModal(dia) {
    selectedDia = dia;
    showModal = true;
  }
  async function ApagaTreino() {
    handleSaveFeedback("", "apagar");
  }
  async function handleSaveFeedback(event, modo = "update") {
    let { feedbackType, stravaLink, feedback, data_feito } = event.detail || "";
    let result;
    if (selectedDia) {
      result = await conexao.conecta(Constantes.api_editar_padrao, {
        id_update: selectedDia.id,
        feito: feedbackType,
        link_strava: stravaLink,
        data_feito: data_feito,
        feedback,
        tabela: "plano_corrida",
        modo_code: modo,
      });
      if (result) {
        if (result.sucesso) {
          selectedDia = null;
          showModal = false;
          window.location.reload();
        }
      }
    }
  }
function InciaTela(){
   
    if (localStorage.getItem("filtro_treino")) {
      filtro = localStorage.getItem("filtro_treino");
      if (filtro == "calendario") {
        soCalendario = true;
      }
    }
    atualizarDatas(currentMonth, currentYear);
    AtualizaScroll();
    if (id_assessoria == 0) {
      id_usuario = $DadosLogin.id_usuario;
    }
    PegaDados();
}
  onMount(() => {

   InciaTela();
  });
  let config = {
    api: Constantes.api_consultar_padrao,
    query_code: "consulta_usuarios_assessorias",
    campos_pesquisaveis: ["nome_usuario", "meta", "ativado"],
    colunas_exibidas: ["nome_usuario", "meta", "ativado"],
    coluna_saida: "id",
    titulo: "Selecione o usuário",
    selecaoUnica: true,
    parametro_adicional: id_assessoria,
  };
  function selecionado(e) {
    id_usuario = "";
    console.log("Selecionado", e.detail);
    id_usuario = e.detail.id;

    PegaDados();
  }
  let filtro = "tudo"; // Variável para armazenar o filtro atual
  function DataCalendarioSelecionada(e) {
    selectedDia = e.detail;
    if (selectedDia) {
      showModal = true;
    }
  }
  $: diasFiltrados = $dias.filter((dia) => {
    if (filtro === "treino") {
      return dia.treinos.length > 0;
    } else if (filtro === "atrasados") {
      return dia.treinos.some(
        (treino) => dia.data.getTime() < hoje.getTime() && treino.feito == 0,
      );
    }
    return true; // Exibe tudo se o filtro for "tudo"
  });
</script>

<CaixaDeDialogo
  {message}
  {title}
  on:close={() => {
    message = "";
    title = "";
  }}
/>
<div class="back">
<br /><br /><br /><br />
{#if id_assessoria > 0}
  <DropSelecao {config} on:selecionado={selecionado} />
{/if}
{#if id_usuario > 0}

  <div class="container">
    <div
      class="sticky-header bg-dark text-white p-1 d-flex justify-content-between align-items-center"
    >
      <button class="btn btn-light" on:click={decrementarMes}>&lt;</button>
      <span class="h4 mb-0">
        {new Date(currentYear, currentMonth).toLocaleDateString("pt-BR", {
          month: "long",
          year: "numeric",
        })}
      </span>
      <button class="btn btn-light" on:click={incrementarMes}>&gt;</button>
    </div>
    <div class="d-flex justify-content-center">Exibir:</div>
    <div class="barra d-flex justify-content-center mb-3">
      <div class="btn-group btn-group-toggle" data-toggle="buttons">
        <button
          class="btn btn-outline-secondary {filtro === 'tudo' ? 'active' : ''}"
          on:click={() => {
            filtro = "tudo";
            soCalendario = false;
            GravaFiltro();
          }}
        >
          Tudo
        </button>
        <button
          class="btn btn-outline-secondary {filtro === 'treino'
            ? 'active'
            : ''}"
          on:click={() => {
            filtro = "treino";
            soCalendario = false;
            GravaFiltro();
          }}
        >
          Dias de Treino
        </button>
        <button
          class="btn btn-outline-secondary {filtro === 'atrasados'
            ? 'active'
            : ''}"
          on:click={() => {
            filtro = "atrasados";
            soCalendario = false;
            GravaFiltro();
          }}
        >
          Atrasados
        </button>
        <button
          class="btn btn-outline-secondary {filtro === 'calendario'
            ? 'active'
            : ''}"
          on:click={() => {
            soCalendario = true;
            filtro = "calendario";
            GravaFiltro();
          }}>Calendário</button
        >
      </div>
    </div>

    {#if isLoading}
      <LoadingTela {isLoading} />
    {:else}
      <div class="calendar-body">
        {#if !soCalendario}
          {#each diasFiltrados as dia}
            <div
              class="calendar-day p-3 border-bottom"
              id="day-{dia.data.getDate()}"
            >
              <div
                class="calendar-header text-center {dia.data.getDate() ==
                hoje.getDate() -1
                  ? 'hoje'
                  : ''}"
              >
                <span class="calendar-date">
                  {new Date(dia.data.getTime() + 24 * 60 * 60 * 1000)
                    .toLocaleDateString("pt-BR", { weekday: "long" })
                    .toUpperCase()},
                  {dia.data.getDate()+1}
                  {dia.data.toLocaleDateString("pt-BR", { month: "short" })}
                </span>
                {#if dia.data.getDate() ==
                hoje.getDate()-1 }

                 (HOJE)
                {/if}
              </div>

              <div class="calendar-content">
                {#if dia.treinos.length > 0}
                  <div class="blocar">
                    {#each dia.treinos as treino}
                      <div
                        class="conteudo-dia  p-3 rounded mb-2 {dia.data.getTime() <
                          hoje.getTime() && treino.feito == 0
                          ? 'data_anterior'
                          : treino.feito == 2
                            ? 'feito'
                            : treino.feito == 1
                              ? 'feito_parcial'
                              : ''}"
                        on:click={() => openFeedbackModal(treino)}
                      >
                      {#if treino.Treino}
                      
                       <div>
                          <strong>Treino:</strong>
                          {@html treino.Treino}
                        </div>
                        <hr />
                      
                      {/if}
                       
                        {#if treino.Intervalos}
                         <div>
                          <strong>Intervalos:<br /></strong>
                          {@html treino.Intervalos}
                        </div>
                        <hr />
                        {/if}
                       {#if treino.observacao}
                        <div>
                          <strong>Observações:<br /></strong>
                          {@html treino.observacao}
                        </div>
                        {/if}
                      </div>
                    {/each}
                  </div>
                {:else}
                  Sem treino
                {/if}
              </div>
            </div>
          {/each}
        {:else}
          <CalendarioTreino
            dias={diasFiltrados} {id_usuario}
            on:selecionado={DataCalendarioSelecionada}
          />
        {/if}
      </div>
    {/if}
    {#if id_usuario > 0}
<CardZonas {id_usuario} {id_assessoria} />
{/if}
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
{/if}
{#if showModal}
<div class="preto">
  <FeedbackModal
    bind:showModal
    on:saveFeedback={handleSaveFeedback}
    on:apaga={ApagaTreino}
    feedbackType={selectedDia.feito}
    stravaLink={selectedDia.link_strava}
    feedback={selectedDia.feedback}
    data_feito={selectedDia.data_feito}
    treino={selectedDia}
    {id_assessoria}
  />
  </div>
{/if}

</div>

<style>
  .calendar-header {
    background-color: #f79b5e; /* Fundo cinza claro */
    border-bottom: 1px solid #dcdcdc; /* Linha separadora */
    padding: 5px 10px; /* Menor padding */
    font-size: 0.85rem; /* Texto menor */
    text-align: left; /* Alinhamento à esquerda */
  }

  .calendar-date {
    display: inline-block;
    color: #333; /* Cor do texto */
    font-weight: bold;
  }
.barra{
   background-color: #3b3b3b; /* Fundo verde claro para o dia atual */
}

  .hoje {
    background-color: #69e054; /* Fundo verde claro para o dia atual */
  }
  .calendar-day {
    margin-bottom: 15px;
  }

  .calendar-content {
    padding: 10px;
  }
  .feito {
    border: 2px solid blue;
  }
  .data_anterior {
    border: 2px solid red;
  }
  .feito_parcial {
    border: 2px solid yellow;
  }

  .conteudo-dia {
    margin-top: 10px;
    background-color: rgb(202, 202, 202);
    padding: 10px;
  }
  .conteudo-sem-treino {
    background-color: #e0e0e0;
    padding: 10px;
  }
  .blocar {
    display: block;
  }
  .back {
       color:rgb(31, 31, 31);
    
    
    background-position: center; /* Para centralizar a imagem */
      background-color: rgba(255, 255, 255, 0.5); /* 50% transparente, cor preta */
  background-blend-mode: overlay; /* Combina a cor com a imagem */
  }
  .preto{
    color:black;
  }
</style>
